/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import NavbarTop from "../global/NavbarTop";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import CustomerStoriesCompanies from "./CustomerStoriesCompanies";
import ic_location from "../../assets/images/pictures/icon/ic_location_30px.svg";
import ic_person from "../../assets/images/pictures/icon/ic_2_person_30px.svg";
import ic_circle_checked from "../../assets/images/pictures/icon/ic_circle_checked_30px.svg";
import ic_big_person_circle from "../../assets/images/pictures/icon/ic_2_person_big_circle_64px.svg";
import CustomerStoriesFooter from "./CustomerStoriesFooter";
import hovi from "../../assets/images/logos/customer/hovi.png";
import { useTranslation } from "react-i18next";

const CustomerStoriesHoovi = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Hoovi | GoPaperless";
  });

  return (
    <>
      <NavbarTop />
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        id="content"
        className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
      >
        <div className="container-fluid bg-color" style={{ height: "400px" }}>
          <div className="row text-center">
            <div className="col-md-12 intro  text-center">
              <img
                width="64"
                height="64"
                src={ic_big_person_circle}
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h1 className="why-head mb-25" data-sr="no reset">
                {t("customer.title")}
              </h1>
              <div className="text-center text-subhead" data-sr="no reset">
                <p>{t("customer.note1")}</p>
              </div>
            </div>
          </div>
        </div>
        <div id="eids">
          <div className="container mt-md-m50">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1">
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="ic-box text-center">
                        <img
                          width="183"
                          height="58"
                          src={hovi}
                          className="img-responsive"
                          alt=""
                          decoding="async"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        <a
                          href="http://www.hoovi.ee"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Hoovi
                        </a>{" "}
                        {t("customer.hovi.note1")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="flex column-wrapper gap-15 pt-10">
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_location} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {" "}
                              {t("customer.hovi.note2")}
                            </p>
                            <p className="font-14">
                              {" "}
                              {t("customer.hovi.note3")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_person} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.hovi.note4")}
                            </p>
                            <p className="font-14">
                              {t("customer.hovi.note5")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_circle_checked} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {" "}
                              {t("customer.hovi.note6-0")}
                            </p>
                            <p className="font-14">
                              {t("customer.hovi.note6")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        <em>{t("customer.hovi.note7")}</em>
                      </p>
                      <p> {t("customer.hovi.note8")}</p>
                      <h2> {t("customer.hovi.note9")}</h2>
                      <p>{t("customer.hovi.note10")}</p>
                      <p>{t("customer.hovi.note11")}</p>
                      <h2> {t("customer.hovi.note12")}</h2>
                      <p>{t("customer.hovi.note13")}</p>
                      <p>{t("customer.hovi.note14")}</p>
                      <p>{t("customer.hovi.note15")}</p>
                      <h2> {t("customer.hovi.note16")}</h2>
                      <p>{t("customer.hovi.note17")}</p>
                      <p>{t("customer.hovi.note18")}</p>
                      <p>{t("customer.hovi.note19")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomerStoriesCompanies currentPage="hoovi" />
        <div className="container security-footer">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 text-center mb-60">
              <h1> {t("customer.note17")}</h1>
              <p>{t("customer.note18")}</p>
              <a
                href="/case-studies"
                className="btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                {t("customer.note19")}
              </a>
            </div>
          </div>
        </div>
        <CustomerStoriesFooter />
        <Footer />
        <NavbarBottom />
      </motion.div>
    </>
  );
};

export default CustomerStoriesHoovi;
